/* eslint-disable no-param-reassign */
export function formatTime(segundos) {
  if (typeof segundos !== 'number' || Number.isNaN(segundos)) {
    return ''
  }

  if (segundos === 0) return '0 segundos'

  const dias = Math.floor(segundos / (3600 * 24))
  segundos -= dias * 3600 * 24

  const horas = Math.floor(segundos / 3600)
  segundos -= horas * 3600

  const minutos = Math.floor(segundos / 60)
  segundos -= minutos * 60

  let result = ''

  if (dias > 0) {
    result += `${dias} dia${dias !== 1 ? 's' : ''}`
  }

  if (horas > 0) {
    if (result !== '') result += ', '
    result += `${horas} hora${horas !== 1 ? 's' : ''}`
  }

  if (minutos > 0) {
    if (result !== '') result += ', '
    result += `${minutos} minuto${minutos !== 1 ? 's' : ''}`
  }

  if (segundos > 0) {
    if (result !== '') result += ' e '
    result += `${segundos} segundo${segundos !== 1 ? 's' : ''}`
  }

  return result
}

export function formatarMinutos(minutos) {
  if (typeof minutos !== 'number' || Number.isNaN(minutos)) {
    return ''
  }

  if (minutos === 0) return '0 minutos'

  const dias = Math.floor(minutos / (60 * 24))
  minutos -= dias * 60 * 24

  const horas = Math.floor(minutos / 60)
  minutos -= horas * 60

  let result = ''

  if (dias > 0) {
    result += `${dias} dia${dias !== 1 ? 's' : ''}`
  }

  if (horas > 0) {
    if (result !== '') result += ', '
    result += `${horas} hora${horas !== 1 ? 's' : ''}`
  }

  if (minutos > 0) {
    if (result !== '') result += ' e '
    result += `${minutos} minuto${minutos !== 1 ? 's' : ''}`
  }

  return result
}
